// Jquery Equal Heights
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

jQuery(document).ready(function($){

	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();

	var equalHeightsFunction = setTimeout(function () {
        $(".equal-row").each(function () {
            $(this).find('.equal').equalHeights();
        });
    }, 500);


	$(".tabs a, .gameTabs a").on('click', function(){
		setTimeout(function () {
				$(".equal-row").each(function () {
				    $(this).find('.equal').height('auto');
				    $(this).find('.equal').equalHeights();
				});
			}, 200);
	});




});

jQuery(window).resize(function(){
	var $ = jQuery;
	// Get Window Width and Height on resize
    windowWidth = $(window).outerWidth();
    windowHeight = $(window).height();
	
	$(".equal-row").each(function () {
        $(this).find('.equal').height('auto');
        $(this).find('.equal').equalHeights();
    });

});
